export const ExtractErrorMessage = (error: any): string => {
  // Handle axios error response
  if (error.response?.data) {
    return (
      error.response.data.error?.message ||
      error.response.data.message ||
      error.response.data.error ||
      JSON.stringify(error.response.data)
    );
  }

  // Handle direct error message
  if (error.message) {
    return error.message;
  }

  // Handle string errors
  if (typeof error === "string") {
    return error;
  }

  // Fallback
  return error.toString() || "";
};

/**
 * @desc The axios wrapper returns the error object instead of throwing, so on a
 * non 2xx the status and body sit under `response` rather than at the top level.
 * Reading only the top level makes a failure look like an empty success, so this
 * reports whichever shape came back.
 * @param {*} jsonResponse whatever the axios wrapper handed back
 * @return {*} {{ status: number, body: any }} 0 when no response arrived at all
 */
export const ReadResponse = (
  jsonResponse: any
): { status: number; body: any } => ({
  status: jsonResponse?.status ?? jsonResponse?.response?.status ?? 0,
  body: jsonResponse?.data ?? jsonResponse?.response?.data ?? {},
});
